export default {
  about: 'À propos',
  addOns: 'Extensions',
  agenda: 'Agenda',
  all: 'Tous',
  browse: 'Parcourir',
  buyTickets: 'Réserver',
  countSelected: '{{count}} sélectionné(s)',
  included: 'Inclus',
  joining: 'En cours',
  joinWaitlist: "Rejoindre la liste d'attente",
  menu: 'Menu',
  noDatesAvailable: 'Aucune date disponible',
  salesEnded: 'Ventes terminées',
  schedule: 'Calendrier',
  seeMoreDates: 'Voir plus de dates',
  soldOut: 'Épuisé',
  viewMore: 'Voir plus',
  viewLess: 'Voir moins',
  location: 'Lieu',
  time: 'Heure',
  at: 'à',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Aucun horaire disponible à cette date pour cette taille de groupe',
  availableTimes: 'Horaires disponibles',
  waitlist: "Liste d'attente",
  continue: 'Continuer',
  tickets: 'Billets',
  ticketsAreNoLongerAvailable: 'Les billets ne sont plus disponibles.',
  checkOutOutOtherExperiences: 'Découvrez nos autres expériences!',
  viewExperiences: 'Voir les expériences',
  from: 'à partir de',
  cancellationPolicy: 'Politique d’annulation',
  rsvp: 'RSVP',
  nights: 'nuit',
  request: 'Demande',
  arrival: 'Arrivée',
  departure: 'Départ',
};
